var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"no-print flex items-center justify-center text-center rounded-lg bg-white p-4 shadow dark:bg-gray-900 md:px-6"},[_c('span',{staticClass:"block text-sm text-gray-500 dark:text-gray-400 sm:text-center"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" PT. Natural Nusantara. All Rights Reserved. v"+_vm._s(_vm.version)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }